import { http } from '@/shared/api'
import type { ApiListResponse } from '@/shared/api'
import type { ReadOptions } from '@/shared/lib'
import { API } from '@/apps/adok/shared/api'

import type { SearchResult } from '../model/types'

// Hand-written rather than `createEntityApi`: search is not a resource. There is no id in
// a path, no show and no writes — one question, answered across several kinds of record.

export interface SearchParams {
  query: string
  limit?: number
}

export const getSearchResults = (params: SearchParams, options?: ReadOptions) =>
  http.get<ApiListResponse<SearchResult>>(API.search, {
    params,
    signal: options?.signal
  })
